export const ROUTES = {
  INDEX: '/tenant-screening-services',
  LANDING: '/tenant-screening-services/landing',
  ADDRESSES: '/tenant-screening-services/addresses',
  APPLICATIONS: '/tenant-screening-services/applications/[listingAlias]',
  ENTER_YOUR_NAME: '/tenant-screening-services/enter-your-name',
  ENTER_YOUR_ADDRESS: '/tenant-screening-services/enter-your-address',
  INVITE_A_RENTER: '/tenant-screening-services/invite-a-renter/[listingAlias]',
} as const;

export const WIZARD_STEPS = {
  ENTER_YOUR_NAME: 'enter-your-name',
  ENTER_YOUR_ADDRESS: 'enter-your-address',
  INVITE_A_RENTER: 'invite-a-renter',
} as const;

export const ANALYTICS_EVENTS = {
  VIEW_LANDING_PAGE: 'ztss_view_landing_page',
  START_SCREENING_TENANTS: 'ztss_start_screening_tenants',
  VIEW_APPLICATIONS: 'ztss_view_applications',
  WHO_SCREENING: 'ztss_who_screening',
  CONTINUE_WHO_SCREENING: 'ztss_continue_who_screening',
  ENTER_YOUR_ADDRESS: 'ztss_enter_your_address',
  CONTINUE_ENTER_YOUR_ADDRESS: 'ztss_continue_enter_your_address',
  INVITE_A_RENTER: 'ztss_invite_a_renter',
  CONTINUE_INVITE_A_RENTER: 'ztss_continue_invite_a_renter',
  SEND_INVITE: 'ztss_send_invite',
  DASHBOARD: 'ztss_dashboard',
  COPY_INVITE_LINK: 'ztss_copy_invite_link',
  DASHBOARD_INVITE: 'ztss_dashboard_invite',
} as const;

export const FAQ_CONTENT = [
  {
    question: 'How does online tenant screening work?',
    answer:
      'All applicants fill out an online rental application with information about their current household makeup, prior residences, contact information and income. We then pull their tenant credit report history through a third-party provider known as Experian™ and run a tenant background check using CIC. Once everything is complete, we will compile everything into a rental application summary for you to review within your Zillow Rental Manager account.',
  },
  {
    question: 'How do I start screening tenants online?',
    answer:
      'First, create an account to start screening tenants with Zillow Rental Manager. You’ll need to include a property contact and the address you’re renting. Once you’ve entered this, you can send a link to the application to potential tenants, you’ll just need their email address. When a renter completes an application, we’ll send you an email notification. All completed applications, which includes a detailed tenant screening report, will be accessible from the “View Applications” link from this page. You only need to send one application per group of renters. The primary applicant can add any co-applicants.',
  },
  {
    question: 'How much does it cost to screen a tenant?',
    answer:
      'Tenant screening reports are free for property managers. Renters pay a tenant screening and application fee, which allows them to apply to your listing and an unlimited number of participating rentals for 30 days.',
  },
  {
    question: 'How long do tenant credit and background checks take?',
    answer:
      'Most tenant credit and background checks will be returned within minutes of the applicant sending the application. On rare occasions, tenant background check requests require a manual review that can take up to 24 hours. We will let you know if a manual review is required.',
  },
  {
    question: 'What does a tenant background and credit check show?',
    answer:
      'A tenant background check typically includes a national criminal search, sex offender search and eviction history. A tenant credit check typically includes a credit score alongside a comprehensive overview of the applicant’s credit history. In some cases, credit and background checks are modified to comply with state and local legal requirements.',
  },
] as const;

export const VALUE_PROPS = [
  {
    title: 'Get a complete tenant overview',
    description:
      'Our online application includes residence history, credit and background checks, eviction history, employment verification, and more.',
    iconName: 'form',
  },
  {
    title: 'No need to pull separate background or credit checks',
    description: 'Each application includes credit checks, eviction and criminal history, and more.',
    iconName: 'magnify',
  },
  {
    title: 'Never track down an application fee again',
    description: 'Applicants pay an affordable screening fee on Zillow, so applications are hassle-free for you.',
    iconName: 'piggyBank',
  },
] as const;
